module.exports = ".modal {\n  background: rgba(0, 0, 0, 0.7);\n}\n"